module.exports = __webpack_public_path__ + "img/button_PDF.5ae6f24d.svg";